export const InviteAcceptRoutes = {
  acceptInvite: "/v1/invite/accept",
} as const;

